import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { useCallback } from 'react';

import connect from 'components/lib/connect';
import NavigateToUrl from 'actions/current_location/navigate_to_url';
import Toast from 'components/common/toast';
import { ToastType } from 'models/toast';
import { useExecuteAction } from 'components/hooks/connect_hooks';

export const ToastsContainer = connect(mapStateToProps)(Toasts);

function mapStateToProps(context) {
  return {
    toasts: context.getProvider('toasts').findAll(),
  };
}

function Toasts({ toasts }) {
  return (
    <React.Fragment>
      {_.map(toasts, toast => (
        <ExtendedToast {...toast} />
      ))}
    </React.Fragment>
  );
}

export function ExtendedToast({ type, message, link, id }) {
  const executeAction = useExecuteAction();
  const onClick = useCallback(() => link && executeAction(NavigateToUrl, link), [link]);

  return (
    <Toast onClick={onClick} key={id} type={type}>
      {message}
    </Toast>
  );
}

ExtendedToast.propTypes = {
  id: PropTypes.string.isRequired,
  message: PropTypes.string,
  type: PropTypes.oneOf(Object.keys(ToastType)).isRequired,
  link: PropTypes.string,
};

export default Toasts;



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/toasts.jsx